import { axiosAjax } from '@app/src/config/axios';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { encrypt } from '@app/src/views/Login/login/helpers/encrypt';

export const serviceEditUser = {
  async getData(values: object, url: string, refreshToken?: string) {
    try {
      const accessToken = refreshToken ? refreshToken : sessionStorage.getItem('accessToken');
      delete values['email']
      const encryptedPayload = encrypt(JSON.stringify(values))
      const { data } = await axiosAjax.put(url, { payload: encryptedPayload }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return data.data;
    } catch (e) {
      throw e.response.data;
    }
  }
}

export const serviceRefreshToken = {
  async getData(refreshToken) {
    try {
      const userId = decodeAccessToken('idUser');
      const expToken = sessionStorage.getItem('accessToken');
      const { data } = await axiosAjax.post(process.env.API_REFRESH_TOKEN, { userId, refreshToken, expToken});
      return data;
    } catch (e) {
      throw e.response.data;
    }
  }
}
